const Bowser = require('bowser');

module.exports = {
	deviceInfo(userAgentString) {

		let device = 'other';
		let OS = 'other';
		let browser = 'other';

		if (!userAgentString) {
			return { device, OS, browser };
		}

		const info = Bowser.getParser(userAgentString);

		const platformInfo = info.getPlatform();
		const browserInfo = info.getBrowser();
		const osInfo = info.getOS();

		if (platformInfo && platformInfo.type) {
			device = platformInfo.type;
		}

		if (browserInfo && browserInfo.name) {
			browser = browserInfo.name.toLowerCase();
		}

		if (osInfo && osInfo.name) {
			OS = osInfo.name
		}

		return { device, OS, browser };
	},
};
